<template>
  <div>
    <h1 class="subtitle is-4 has-text-centered">
      Bridge Transaction History
    </h1>
    <article class="message">
      <div class="message-body">
        <span class="icon has-text-info">
         <i class="fas fa-info-circle"></i>
        </span>
        Note: Supported networks ETH, Matic, ARB, OP
      </div>
    </article>
    <div class="table-container">
      <!-- ปุ่มสลับล่าสุดและหลังสุด -->
      <!-- <div class="buttons is-centered">
        <button @click="reverseTransactions">Reverse Transactions</button>
      </div> -->
<!-- <div class="buttons is-centered">
  <button @click="reverseTransactions" class="arrow-button">
    <i class="fas fa-arrow-up"></i>
  </button>
</div> -->

      <table class="table is-fullwidth   table is-hoverable">
        <thead>
          <tr>
            <th>Action</th>
            <th>From</th>
            <th>To</th>
            <th>Token Address</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(t, key) in paginatedTransactions" :key="key">
            <td>{{ t.name }}</td>
            <td>{{ t.from }}</td>
            <td>{{ t.to }}</td>
            <td>{{ t.token }}</td>
            <td>{{ t.amount }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ส่วนของปุ่มเลื่อนหน้า -->
    <div class="pagination is-centered">
      <ul class="pagination-list">
        <!-- ปุ่มหน้าก่อนหน้า -->
        <li>
          <a
            @click="goToPage(currentPage - 1)"
            :class="{ 'is-disabled': currentPage === 1 }"
            class="pagination-previous"
          >&laquo; Previous</a>
        </li>

        <!-- แสดงข้อมูลหน้าและจำนวนหน้าทั้งหมด -->
        <li>
          <span class="pagination-ellipsis">
             {{ currentPage }} of {{ totalPages }}
          </span>
        </li>

        <!-- ปุ่มหน้าถัดไป -->
        <li>
          <a
            @click="goToPage(currentPage + 1)"
            :class="{ 'is-disabled': currentPage === totalPages }"
            class="pagination-next"
          >Next &raquo;</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import loader from '@/mixins/loader'
import utilities from '@/mixins/utilities'
import { ethers } from 'ethers'
import Bridge from '@/constants/abis/Bridge'

export default {
  mixins: [
    loader,
    utilities
  ],
  data () {
    return {
      transactions: [],
      currentPage: 1, // หน้าปัจจุบัน
      perPage: 30 // จำนวนรายการต่อหน้า
    }
  },
  computed: {
    ...mapState([
      'chainId'
    ]),
    paginatedTransactions () {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      const reversedTransactions = this.transactions.slice(start, end).reverse() // Reverse the order
      return reversedTransactions
    },
    totalPages () {
      return Math.ceil(this.transactions.length / this.perPage)
    }
  },
  watch: {
    chainId () {
      this.fetchPageData()
    }
  },
  async mounted () {
    await this.fetchPageData()
  },
  methods: {
    async fetchPageData () {
      this.execWithLoader(async () => {
        this.transactions = []
        const provider = new ethers.providers.EtherscanProvider(this.chainId, 'PIGCVTAJNVTDUDPKB5AJAXGB43Q27ZB5PH')
        const history = await provider.getHistory(this.$store.state.account)
        const iface = new ethers.utils.Interface(Bridge.abi)

        for (let i = 0; i < history.length; i++) {
          const tx = history[i]
          try {
            const decodedInput = iface.parseTransaction({ data: tx.data, value: tx.value })
            switch (decodedInput.name) {
              case 'unlockToBridgeIn': // release
              case 'mintToBridgeOut': // mint
                this.transactions.push(this.parseClaim(decodedInput))
                break
              case 'bridgeOut': // lock
              case 'bridgeIn': // burn
                this.transactions.push(this.parseBridge(decodedInput))
                break
              default:
                console.log('Unsupported tx: ', decodedInput.name)
            }
          } catch {}
        }
      }, 'Error fetching history')
    },

    parseBridge (tx) {
      return {
        name: 'Bridge In', //Bridge
        from: this.chainId,
        to: tx.args[0],
        token: tx.args[1],
        amount: ethers.utils.formatEther(tx.args[2])
      }
    },
    
    parseClaim (tx) {
      const args = tx.args[0]
      return {
        name: 'Bridge Out', //Claim
        from: args[0],
        to: this.chainId,
        token: args[1],
        amount: ethers.utils.formatEther(args[2])
      }
    },

    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    reverseTransactions() {
      this.transactions.reverse()
    }
  }
}
</script>
